import { Routes } from "@angular/router";
import { ChangepasswordComponent } from "src/app/authentication/changepassword/changepassword.component";
import { EmailsentComponent } from "src/app/authentication/emailsent/emailsent.component";
import { ForgottenpasswordComponent } from "src/app/authentication/forgottenpassword/forgottenpassword.component";
import { LoginComponent } from "src/app/authentication/login/login.component";
import { RegistrationComponent } from "src/app/authentication/registration//registration.component";

export const AUTH_ROUTES: Routes = [
    {
      path: 'registration', component: RegistrationComponent
    },
    {
      path: 'login', component: LoginComponent
    },
    {
      path: 'password/forgotten', component: ForgottenpasswordComponent,
    },
    {
      path: 'email/sent', component: EmailsentComponent
    },
    {
      path: 'password/reset/new/:hash', component: ChangepasswordComponent
    }
];